export const ApprovalStatusEnum = {
    OPENED: {
        key: 100,
        value: 'pending',
    },
    COMPLETED: {
        key: 101,
        value: 'completed',
    },
    APPROVED: {
        key: 1,
        value: 'approved',
    },
    REJECTED: {
        key: 2,
        value: 'rejected',
    },
    CANCEL: {
        key: 3,
        value: 'cancel',
    },
};
